import React, { useState, useEffect } from "react";

export default function AnimatedTextWithCursor({
  text,
}: {
  text: React.ReactNode;
}) {
  const textAsString = getNodeAsString(text);
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    if (displayedText.length < textAsString.length) {
      const timer = setTimeout(() => {
        setDisplayedText(textAsString.slice(0, displayedText.length + 1));
      }, 5);
      return () => clearTimeout(timer);
    }
  }, [textAsString, displayedText]);

  return (
    <div style={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
      {displayedText}
      {displayedText.length < textAsString.length && (
        <span className="pathbee-blinking" style={{ marginLeft: 2 }}>
          |
        </span>
      )}
    </div>
  );
}

/**
 * ノードを文字列に変換する
 * @param node ノード
 * @returns 文字列
 */
function getNodeAsString(node: React.ReactNode): string {
  if (typeof node === "string") {
    return node;
  }
  if (React.isValidElement(node)) {
    const props = node.props as { children?: React.ReactNode };
    const children = props.children;
    return typeof children === "string" ? children : "";
  }
  return "";
}
